module.exports = __webpack_public_path__ + "img/cloudguard_catalogue.ab70ecd.png";